// (C) Copyright IBM Deutschland GmbH 2021.  All rights reserved.

/***********************************************************************************************
imports
***********************************************************************************************/

import React from 'react';
import {View, Image, StyleSheet, Text, Platform} from 'react-native';
import PropTypes from 'prop-types';
import { navigationPropType } from '../propTypes';

// custom components
import { Banner, ScrollIndicatorWrapper } from '../components/shared';

// services & config
import translate from '../services/localization';
import { appConfig, theme } from '../config';
import {isMobile} from "react-device-detect";
import {useSelector} from "react-redux";
import moment from 'moment';

const defaultLogo = require('../CUSTOMIZATION/images/mii_acribis_landscape.png');

/***********************************************************************************************
 * component:
 * renders the legal information screen which contains legal information about the study
 *
 * @param {object} props
 * @param {object} props.navigation the navigation object provided by 'react-navigation'
 ***********************************************************************************************/
function ThankYouScreen({ navigation }) {
  const currentYear = new Date().getFullYear();
  const {fontScaleFactor} = useSelector(
      (state) => state.Globals
  );

  return (
    <View>
      <View style={localStyle.wrapper}>
        {/* banner */}
        <Banner
            nav={navigation}
            title={translate('ThankYouScreen').title}
            subTitle={translate('ThankYouScreen').subTitle}
            noMenu
            isCheckIn={true}
            noWayBack={true}
        />
        {/* content */}
        <View style={{ ...localStyle.flexi, ...localStyle.wrapper }}>
          <ScrollIndicatorWrapper>
            <View style={{ ...localStyle.wrapper, ...localStyle.top }}>

              <Text style={{marginTop: 10, textAlign: 'center', fontSize: localStyle.infoText.fontSize * fontScaleFactor }}>
                {translate('survey').finishedAllTitle}
              </Text>

              <Text style={{marginTop: 10, textAlign: 'center', fontSize: localStyle.infoText.fontSize * fontScaleFactor }}>
                {translate('survey').finishedAllCloseHint}
              </Text>

              <Image
                  resizeMode="contain"
                  style={{marginTop: 100, height : 50, width: '100%'}}
                  source={defaultLogo}
              />

              <Text style={{marginTop: 10, marginBottom: 20, textAlign: 'center', fontSize: fontScaleFactor * 13 }}>
                {translate('about').devNotice}.{'\n'}
                &copy; {moment().format('YYYY')}. {translate('about').allRightsReserved}.
              </Text>

            </View>
          </ScrollIndicatorWrapper>
        </View>
      </View>
    </View>
  );
}

ThankYouScreen.propTypes = {
  navigation: PropTypes.shape(navigationPropType).isRequired,
};

/***********************************************************************************************
localStyle
***********************************************************************************************/

const localStyle = StyleSheet.create({
  wrapper: {
    height: '100%',
    width: Platform.OS === 'web' && isMobile ? '100%' : 1000,
    alignSelf: 'center',
    flexDirection: 'column',
    backgroundColor: theme.values.defaultBackgroundColor,
  },

  flexi: {
    flex: 1,
  },

  title: {
    ...theme.fonts.title,
    textAlign: 'center',
    alignSelf: 'center',
    color: theme.values.defaultTitleTextColor,
  },

  top: {
    paddingStart: 20,
    paddingEnd: 20,
    justifyContent: 'left',
    alignItems: 'left',
    paddingTop: appConfig.scaleUiFkt(15),
    marginBottom: appConfig.scaleUiFkt(35),
  },

  infoText: {
    marginTop: appConfig.scaleUiFkt(20),
    marginBottom: appConfig.scaleUiFkt(20),
    marginLeft: appConfig.scaleUiFkt(40),
    marginRight: appConfig.scaleUiFkt(40),
    textAlign: 'justify',
    alignSelf: 'auto',
    color: theme.colors.accent4,
    ...theme.fonts.body,
  },

  titleText: {
    width: '80%',
    textAlign: 'center',
    alignSelf: 'center',
    ...theme.fonts.header2,
  },
});

/***********************************************************************************************
export
***********************************************************************************************/

export default ThankYouScreen;
